export default "__VITE_ASSET__BhJ5$T0J__"